import Vue from 'vue'

const state = { profile: {} }

const getters = {
  getProfile: (state) => state.profile || null,
  getTecnico: (state) => state.profile.Tecnico || null,
  getPrioridad: (state) => state.profile.Prioridad || 1,
  getClient: (state) => state.profile.Cliente || null,
  getInstalacion: (state) => state.profile.Instalacion || null,
  isProfileLoaded: (state) => state.profile && !!state.profile.User,
  Role: (state, getters) => (getters.isProfileLoaded ? state.profile.Role : null),
  Cliente: (state, getters) => (getters.Role ? state.profile.Role === 'Cliente' : false),
  Tecnico: (state, getters) => (getters.Role ? state.profile.Role === 'Tecnico' : false)
}

const actions = {
  USER_REQUEST: ({ commit, dispatch }, data) => {
    commit('USER_SUCCESS', data)
  }
}

const mutations = {
  USER_REQUEST: (state) => {},
  USER_SUCCESS: (state, data) => {
    delete data['Token']
    Vue.set(state, 'profile', data)
  },
  USER_ERROR: (state) => {},
  AUTH_LOGOUT: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
